import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { ApiResponse } from '../models/api-response';
import { map } from 'rxjs';
import { Video } from '../models/video';

@Injectable({
  providedIn: 'root'
})
export class VideosService {

  http = inject(HttpClient);

  getVideos(id : string) {

    const params = new HttpParams().set('id', id);

    return this.http
      .get<ApiResponse<Video[]>>(
        `${environment.apiUrl}/playlist/videos`,
        {params}
      )
      .pipe(map(response => response.data));

  }
}